import { HStack, StackProps } from '@chakra-ui/react';
import React from 'react';
import { SvgIcon } from './chakra-components';
import * as CoreImages from 'core/img';

type Props = { variant: 'success' | 'warning' | 'error' } & StackProps;

export function NotificationBar({ variant, children, ...rest }: Props) {

	const iconSrc = {
		'success': CoreImages.Success,
		'warning': CoreImages.Warning,
		'error': CoreImages.Error,
		'info': CoreImages.Info
	};

	return (<HStack h='7' w='full' textAlign={'right'} justifyContent={'right'} paddingY={'1.5'} {...rest}>
		<SvgIcon src={iconSrc[variant]} color={variant} h='3.5' w='3.5' />
		{children}
	</HStack>);
}